import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative py-2 font-bold text-center status" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" You are currently not logged in. To play along, ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("sign up or sign in")

import { RouterLink } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(RouterLink), {
      class: "text-primary",
      to: "/login"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}
}

})